<template>
  <div class="container">
    <span class="tit">Submission History</span>
    <p class="filters">
      Filter by status:
      <a @click="setFilterStatus({})">All</a>
      <a
        v-for="st in Object.keys(status)"
        @click="setFilterStatus({ key: 'status', value: status[st] })"
      >
        {{ status[st] }}</a
      >
    </p>
    <Table
      :items="articleList"
      :columns="[
        'title',
        'term',
        ...(['admin', 'god'].includes(role) ? ['author'] : []),
        'status',
        'date',
      ]"
      :actions="actions[role]"
      :filterField="filterStatus"
    >
    </Table>
  </div>
</template>

<script>
import Table from "./Table";
import { articleDAO as article, status } from "./helpers";

export default {
  name: "SubmissionsList",
  components: { Table },
  data() {
    return {
      articleList: [],
      filterStatus: {},
      actions: {
        author: {
          view: "viewLink",
          edit: "editLink",
        },
        admin: {
          view: "viewLink",
          edit: "editLink",
          review: "reviewLink",
        },
        reviewer: {
          review: "reviewLink",
        },
        god: {
          view: "viewLink",
          edit: "editLink",
          review: "reviewLink",
        },
      },
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    role() {
      return this.$store.getters.role;
    },
    status() {
      return status[this.$store.getters.role];
    },
  },
  mounted() {
    if (this.isLoggedIn) {
      this.axios
        .get(process.env.API_BASE_URL + "/articles/user", {
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.token,
          },
        })
        .then((response) => {
          this.articleList = response.data.map(article);
        });
    }
  },
  methods: {
    setFilterStatus(filter) {
      this.filterStatus = filter;
    },
  },
};
</script>

<style lang="scss">
.tit {
  display: inline-block;
}

.filters {
  text-align: right;
  a {
    cursor: pointer;
    &:after {
      content: " | ";
    }
    &:last-child:after {
      content: "";
    }
  }
}
</style>



// WEBPACK FOOTER //
// SubmissionsList.vue?654e7a8b